import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBankmin = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.97 7.218c.482 0 .683-.62.291-.906l-5.967-4.34a.497.497 0 0 0-.587 0l-5.968 4.34a.501.501 0 0 0 .294.906H3v5.844H1.875a.125.125 0 0 0-.125.125V14c0 .068.057.124.125.124h12.25A.125.125 0 0 0 14.25 14v-.812a.125.125 0 0 0-.125-.125H13V7.218h.97ZM8 3.073l4.236 3.081H3.764L8 3.073ZM4.125 7.218h1.829v5.844H4.125V7.218Zm2.954 0h1.828v5.844H7.079V7.218Zm4.796 5.844h-1.843V7.218h1.843v5.844Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgBankmin);
export { ForwardRef as ReactComponent };
